function ProfileIcon(props)
{
    return(
       <svg className={props.class} viewBox="0 0 32 40" x="0px" y="0px"><g><path d="M6.337,26.106a13.936,13.936,0,0,0,19.326,0,1.054,1.054,0,0,0,.092-.084,14,14,0,1,0-19.51,0A1.054,1.054,0,0,0,6.337,26.106ZM16,28a11.941,11.941,0,0,1-7.91-3,8.459,8.459,0,0,1,15.82,0A11.941,11.941,0,0,1,16,28ZM11.731,13.268A4.269,4.269,0,1,1,16,17.537,4.274,4.274,0,0,1,11.731,13.268ZM16,4a11.983,11.983,0,0,1,9.409,19.425,10.527,10.527,0,0,0-5.634-5.164,6.269,6.269,0,1,0-7.55,0,10.527,10.527,0,0,0-5.634,5.164A11.983,11.983,0,0,1,16,4Z"/></g></svg>
    )
}

export default ProfileIcon